import React, { Component } from 'react';
import { connect } from 'react-redux';
import debounce from 'debounce';

import Dropdown from './../Dropdown';

import { userSetFieldFetch } from './../../store/user/actions';

const fieldName = 'major';

class MajorDropdown extends Component {
    constructor(props) {
        super(props);

        this.state = {
            inputValue: ''
        };

        this.onChange = this.onChange.bind(this);
        this.debounceSave = debounce(this.debounceSave, 1000);
    }

    onChange(event) {
        const inputValue = event.target.value;
        const { save } = this.props;
        this.setState({ inputValue });
        this.debounceSave(inputValue, save);
    }

    debounceSave(value, method) {
        method(value);
    }

    componentDidMount() {
        const { value } = this.props;
        this.setState({ inputValue: value });
    }

    render() {
        const { inputValue } = this.state;
        const errorClassName = !inputValue ? 'text-danger' : null;
        const text = inputValue || 'Select';
        return (
            <div>
                <span className={errorClassName}>Major:</span>
                <Dropdown buttonClassName="lnk-dropdown" text={text}>
                    <input className="input-text" type="text" maxLength="100" onChange={this.onChange} autoFocus value={inputValue} placeholder="Enter your major" />
                </Dropdown>
            </div>
        );
    }
}

const mapStateToProps = state => ({
    value: state.user[fieldName]
});
const mapDispatchToProps = dispatch => ({
    save: value => dispatch(userSetFieldFetch(fieldName, value))
});

export default connect(mapStateToProps, mapDispatchToProps)(MajorDropdown);


// WEBPACK FOOTER //
// ./src/components/profile/MajorDropdown.js